import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card border border-2 border-custom-300 border-hover" }
const _hoisted_2 = { class: "pt-6 text-center" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "card-body py-3" }
const _hoisted_5 = { class: "fs-3 fw-bolder text-dark" }
const _hoisted_6 = { class: "text-gray-400 fw-bold fs-5 mt-1 mb-7" }
const _hoisted_7 = { class: "fw-bold text-gray-400" }
const _hoisted_8 = { class: "fs-7 text-gray-800 fw-bolder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("i", {
          class: _normalizeClass([_ctx.icon, "px-3"])
        }, null, 2)
      ]),
      _createElementVNode("span", {
        class: _normalizeClass([_ctx.statusBadgeColor, "badge"])
      }, _toDisplayString(_ctx.status), 3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.description), 1),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.badges > 3 ? 'flex-wrap' : '', "d-flex text-center justify-content-center"])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.badges, (badgeNumber) => {
          return (_openBlock(), _createElementBlock("div", {
            key: badgeNumber.length,
            style: _normalizeStyle(_ctx.badges > 3 ? 'width: 30%;' : ''),
            class: "border border-custom-300 border-dashed rounded py-3 px-4 mx-2 mb-3"
          }, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.infoBadgeTitle[badgeNumber - 1]), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.infoBadgeDescription[badgeNumber - 1]), 1)
          ], 4))
        }), 128))
      ], 2)
    ])
  ]))
}